import React from "react";
import { Modal, Text, Box, BlockStack, Scrollable } from "@shopify/polaris";

const optimisedArticleStyles = `
  .optimised-article-preview p {
    margin: 0 0 0px 0;
  }
  .optimised-article-preview h1,
  .optimised-article-preview h2,
  .optimised-article-preview h3,
  .optimised-article-preview h4 {
    margin: 12px 0 0px 0;
  }
  .optimised-article-preview ul,
  .optimised-article-preview ol {
    margin: 0 0 16px 0;
    padding-left: 24px;
  }
  .optimised-article-preview li {
    margin-bottom: 8px;
  }
  .optimised-article-preview p:last-child {
    margin-bottom: 0;
  }
`;

/**
 * OptimisedArticleModal
 *
 * Shows a full preview of the AI-optimised article content before any changes
 * are written back to Shopify. The original article is left completely untouched
 * until the user explicitly clicks "Save as Draft".
 *
 * Props:
 *   open             {boolean}  – controls modal visibility
 *   onClose          {function} – called when the user cancels or closes
 *   onConfirm        {function} – called when the user confirms replacement
 *   optimisedArticle {object}  – { article_title, article_body }
 *   isConfirming     {boolean}  – shows a loading state on the confirm button
 */
function OptimisedArticleModal({
  open,
  onClose,
  onConfirm,
  optimisedArticle,
  isConfirming = false,
}) {
  if (!optimisedArticle) return null;

  return (
    <>
      <style>{optimisedArticleStyles}</style>
      <Modal
        open={open}
        onClose={onClose}
        title="Optimised Article Preview"
        large
        primaryAction={{
          content: "Save as Draft",
          onAction: onConfirm,
          loading: isConfirming,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: onClose,
            disabled: isConfirming,
          },
        ]}
      >
        {/* <Modal.Section>
          <Text tone="subdued" as="p">
            We’ll save this as a new draft copy so your existing article stays
            untouched. Review and publish it from Shopify when you’re ready.
          </Text>
        </Modal.Section> */}

        <Modal.Section>
          <BlockStack gap="400">
            {/* Article title preview */}
            <Box>
              <Text variant="headingMd" as="h3">
                {optimisedArticle.article_title}
              </Text>
            </Box>

            {/* Article body preview — rendered as HTML */}
            <Scrollable style={{ maxHeight: "480px" }} shadow>
              <Box
                padding="400"
                background="bg-surface-secondary"
                borderRadius="200"
              >
                <div
                  className="optimised-article-preview"
                  style={{
                    lineHeight: "1.8",
                    fontSize: "14px",
                    color: "var(--p-color-text)",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: optimisedArticle.article_body,
                  }}
                />
              </Box>
            </Scrollable>
          </BlockStack>
        </Modal.Section>
      </Modal>
    </>
  );
}

export default OptimisedArticleModal;